










import Popup from '@/views/organisms/Popup.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import ContainerTable from '@/views/organisms/ContainerTable.vue'
import PopupComfirmEdit from '@/views/template/PopupComfirmEdit.vue'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'

export default
  components: {
    Popup
    ContainerTable
    PopupComfirmEdit
    PopupComfirmDelete
  }

  data: () ->
    isShowPopup: {}
    postParam: {}

  props:
    title:
      type: String
      default: ''
    id:
      type: String
      default: ''
    containerList:
      type: Array
      default: []

  created: () ->
    store.dispatch('initPostParam')

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    click: (v) ->
      # @$emit('click', v)
      @postParam = v
      @showPopup('edit')
    clickDelete: (v) ->
      @postParam = v
      @showPopup('delete')
    save: (e) ->
      @$emit('click', @postParam)
    send: (e) ->
      @$emit('clickDelete', @postParam)
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
  }
